/** @param {string} product @returns {string[]} */
export function legacyEnforcementLinesForProduct(product) {
  if (product !== "hrm") return []

  return [
    "# Legacy HRM compatibility setting; the current WMS backend ignores it.",
    "LICENSE_ENFORCEMENT_ENABLED=true",
  ]
}
